import React from 'react';
import clsx from 'clsx';
import Form from 'react-bootstrap/Form';
import './BaySwitch.scss';

import HelpIcon from '../Icons/HelpIcon';

interface BaySwitchProps {
	/** The label text displayed next to the switch */
	label?: string;
	/** Unique identifier for the switch input */
	id?: string;
	/** Name attribute for the form input */
	name?: string;
	/** Whether the switch is checked/on */
	checked?: boolean;
	/** Callback function called when the switch state changes */
	onChange?: () => void;
	/** Whether the switch is disabled */
	disabled?: boolean;
	/** Whether to show the tooltip help icon */
	showTooltip?: boolean;
	/** Content to display in the tooltip */
	tooltipContent?: string;
	/** Placement of the tooltip */
	tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
	/** Additional CSS classes to apply */
	className?: string;
	/** Translation function for internationalization */
	//t?: () => string;
}

const BaySwitch = ({
	label,
	id,
	name,
	checked = false,
	onChange = () => {},
	disabled = false,
	showTooltip = false,
	tooltipContent = '',
	tooltipPlacement = 'top',
	className = '',
}: BaySwitchProps) => {
	const switchClasses = clsx('bay-switch', className);

	return (
		<div className={switchClasses}>
			<Form.Check
				checked={checked}
				className="bay-switch-input"
				disabled={disabled}
				id={id}
				label={label}
				name={name}
				type="switch"
				onChange={onChange}
			/>
			{showTooltip && (
				<div className="bay-switch-tooltip ms-2">
					<HelpIcon
						filled
						color="var(--bs-gray-700)"
						content={tooltipContent}
						placement={tooltipPlacement}
					/>
				</div>
			)}
		</div>
	);
};

export default BaySwitch;
